export default "__VITE_ASSET__DPr$Guhx__"